module.exports = __webpack_public_path__ + "components/t-shirt-comp/static/Nazare-63830807f999107a6697b59ef27af422.jpg";